/**
 * Mr. Sneakerseller Chatbot Widget
 * Version: 1.0.0
 * A vanilla JavaScript chatbot widget for Shopify
 */
(function() {
  'use strict';

  // Configuration from global variable
  const config = Object.assign({
    apiUrl: '',
    primaryColor: '#000000',
    language: 'de-CH',
    autoOpenDelay: 15000,
    enableProactive: false,
    enableQuickActions: true,
    maxMessageLength: 500,
    sessionTimeout: 3600000,
    retryAttempts: 3,
    retryDelay: 2000
  }, window.CHATBOT_CONFIG || {});

  // Storage keys
  const STORAGE_KEYS = {
    SESSION_ID: 'chatbot_session_id',
    LAST_ACTIVITY: 'chatbot_last_activity',
    MSG_COUNT: 'chatbot_msg_count',
    HISTORY: 'chatbot_history',
    FEEDBACK_SUBMITTED: 'chatbot_feedback_submitted'
  };

  // ==========================================================================
  // Translations
  // ==========================================================================
  const TRANSLATIONS = {
    en: {
      // Quick actions
      quickAction_orderStatus: 'Order Status',
      quickAction_orderStatus_msg: 'Where is my order?',
      quickAction_sizing: 'Sizing Guide',
      quickAction_sizing_msg: 'How does the sizing work?',
      quickAction_return: 'Returns',
      quickAction_return_msg: 'How can I return an item?',
      quickAction_email: 'Email Support',
      quickAction_emailSubject: 'Support%20Request',

      // Welcome message
      welcomeMessage: 'Hello! How can I help you today?',

      // Input
      inputPlaceholder: 'Type your message...',

      // Feedback
      feedbackButton: 'Give feedback',
      feedbackTitle: 'How was your experience?',
      feedbackRating: 'Rating',
      feedbackStar1: '1 star',
      feedbackStar2: '2 stars',
      feedbackStar3: '3 stars',
      feedbackStar4: '4 stars',
      feedbackStar5: '5 stars',
      feedbackHint1: 'Very bad',
      feedbackHint2: 'Bad',
      feedbackHint3: 'Okay',
      feedbackHint4: 'Good',
      feedbackHint5: 'Excellent',
      feedbackComment: 'Optional comment...',
      feedbackSubmit: 'Submit',
      feedbackSubmitting: 'Submitting...',
      feedbackError: 'Error - Try again',
      feedbackSuccess: 'Thank you for your feedback!',
      feedbackAlreadySent: 'Feedback already sent',
      feedbackClose: 'Close',

      // Banners
      offlineMessage: 'No internet connection',
      rateLimitWarning: '{remaining} messages remaining',
      rateLimitReached: 'You have reached the message limit. Please contact support@mrsneakerseller.ch for further assistance.',

      // Errors
      errorGeneric: 'Sorry, an error occurred. Please try again later.',
      errorTimeout: 'Timeout. Please try again.',
      errorOffline: 'No internet connection. Please check your connection.',
    },
    de: {
      // Quick actions
      quickAction_orderStatus: 'Bestellstatus',
      quickAction_orderStatus_msg: 'Wo ist meine Bestellung?',
      quickAction_sizing: 'Grössenberatung',
      quickAction_sizing_msg: 'Wie fällt die Grösse aus?',
      quickAction_return: 'Rückgabe',
      quickAction_return_msg: 'Wie kann ich zurückgeben?',
      quickAction_email: 'E-Mail Support',
      quickAction_emailSubject: 'Support%20Anfrage',

      // Welcome message
      welcomeMessage: 'Hallo! Wie kann ich Ihnen helfen?',

      // Input
      inputPlaceholder: 'Schreiben Sie Ihre Nachricht...',

      // Feedback
      feedbackButton: 'Feedback geben',
      feedbackTitle: 'Wie war Ihre Erfahrung?',
      feedbackRating: 'Bewertung',
      feedbackStar1: '1 Stern',
      feedbackStar2: '2 Sterne',
      feedbackStar3: '3 Sterne',
      feedbackStar4: '4 Sterne',
      feedbackStar5: '5 Sterne',
      feedbackHint1: 'Sehr schlecht',
      feedbackHint2: 'Schlecht',
      feedbackHint3: 'Okay',
      feedbackHint4: 'Gut',
      feedbackHint5: 'Ausgezeichnet',
      feedbackComment: 'Optionaler Kommentar...',
      feedbackSubmit: 'Absenden',
      feedbackSubmitting: 'Wird gesendet...',
      feedbackError: 'Fehler - Erneut versuchen',
      feedbackSuccess: 'Vielen Dank für Ihr Feedback!',
      feedbackAlreadySent: 'Feedback bereits gesendet',
      feedbackClose: 'Schliessen',

      // Banners
      offlineMessage: 'Keine Internetverbindung',
      rateLimitWarning: 'Noch {remaining} Nachrichten verfügbar',
      rateLimitReached: 'Sie haben das Nachrichtenlimit erreicht. Bitte wenden Sie sich an support@mrsneakerseller.ch für weitere Hilfe.',

      // Errors
      errorGeneric: 'Entschuldigung, es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
      errorTimeout: 'Zeitüberschreitung. Bitte erneut versuchen.',
      errorOffline: 'Keine Internetverbindung. Bitte überprüfen Sie Ihre Verbindung.',
    },
    fr: {
      // Quick actions
      quickAction_orderStatus: 'Statut de commande',
      quickAction_orderStatus_msg: 'Où est ma commande?',
      quickAction_sizing: 'Guide des tailles',
      quickAction_sizing_msg: 'Comment taillent les articles?',
      quickAction_return: 'Retours',
      quickAction_return_msg: 'Comment puis-je retourner un article?',
      quickAction_email: 'Support par e-mail',
      quickAction_emailSubject: 'Demande%20de%20support',

      // Welcome message
      welcomeMessage: 'Bonjour! Comment puis-je vous aider?',

      // Input
      inputPlaceholder: 'Écrivez votre message...',

      // Feedback
      feedbackButton: 'Donner un avis',
      feedbackTitle: 'Comment était votre expérience?',
      feedbackRating: 'Note',
      feedbackStar1: '1 étoile',
      feedbackStar2: '2 étoiles',
      feedbackStar3: '3 étoiles',
      feedbackStar4: '4 étoiles',
      feedbackStar5: '5 étoiles',
      feedbackHint1: 'Très mauvais',
      feedbackHint2: 'Mauvais',
      feedbackHint3: 'Correct',
      feedbackHint4: 'Bien',
      feedbackHint5: 'Excellent',
      feedbackComment: 'Commentaire optionnel...',
      feedbackSubmit: 'Envoyer',
      feedbackSubmitting: 'Envoi en cours...',
      feedbackError: 'Erreur - Réessayer',
      feedbackSuccess: 'Merci pour votre avis!',
      feedbackAlreadySent: 'Avis déjà envoyé',
      feedbackClose: 'Fermer',

      // Banners
      offlineMessage: 'Pas de connexion internet',
      rateLimitWarning: '{remaining} messages restants',
      rateLimitReached: 'Vous avez atteint la limite de messages. Veuillez contacter support@mrsneakerseller.ch pour plus d\'aide.',

      // Errors
      errorGeneric: 'Désolé, une erreur s\'est produite. Veuillez réessayer plus tard.',
      errorTimeout: 'Délai dépassé. Veuillez réessayer.',
      errorOffline: 'Pas de connexion internet. Veuillez vérifier votre connexion.',
    }
  };

  // ==========================================================================
  // i18n Module
  // ==========================================================================
  const i18n = {
    locale: 'en',

    init() {
      this.locale = this.detectLocale();
    },

    detectLocale() {
      // Check URL path for locale (e.g., /de/, /fr/, /en/)
      const path = window.location.pathname;
      const match = path.match(/^\/(de|fr|en)(\/|$)/i);

      if (match) {
        return match[1].toLowerCase();
      }

      // Fallback to English
      return 'en';
    },

    t(key, replacements = {}) {
      const translations = TRANSLATIONS[this.locale] || TRANSLATIONS.en;
      let text = translations[key] || TRANSLATIONS.en[key] || key;

      // Replace placeholders like {remaining}
      Object.keys(replacements).forEach(placeholder => {
        text = text.replace(`{${placeholder}}`, replacements[placeholder]);
      });

      return text;
    },

    getLocale() {
      return this.locale;
    }
  };

  // Default quick actions - returns translated actions
  function getDefaultQuickActions() {
    return [
      { label: i18n.t('quickAction_orderStatus'), emoji: '\u{1F4E6}', action: 'message', value: i18n.t('quickAction_orderStatus_msg') },
      { label: i18n.t('quickAction_sizing'), emoji: '\u{1F4CF}', action: 'message', value: i18n.t('quickAction_sizing_msg') },
      { label: i18n.t('quickAction_return'), emoji: '\u{1F504}', action: 'message', value: i18n.t('quickAction_return_msg') },
      { label: i18n.t('quickAction_email'), emoji: '\u{1F4AC}', action: 'mailto', value: `mailto:support@mrsneakerseller.ch?subject=${i18n.t('quickAction_emailSubject')}` }
    ];
  }

  // Application state
  const state = {
    isOpen: false,
    sessionId: null,
    messageCount: 0,
    history: [],
    isLoading: false,
    isOffline: !navigator.onLine,
    isRateLimited: false,
    dynamicActions: null,
    feedbackSubmitted: false,
    isFeedbackOpen: false
  };

  // ==========================================================================
  // Utils Module
  // ==========================================================================
  const utils = {
    generateUUID() {
      if (crypto.randomUUID) {
        return crypto.randomUUID();
      }
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },

    sanitizeInput(str) {
      if (!str) return '';
      return str
        .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '')
        .replace(/<iframe[^>]*>[\s\S]*?<\/iframe>/gi, '')
        .replace(/on\w+\s*=\s*["'][^"']*["']/gi, '')
        .trim();
    },

    formatTimestamp(date) {
      const d = date instanceof Date ? date : new Date(date);
      const localeMap = { de: 'de-CH', fr: 'fr-CH', en: 'en-US' };
      const locale = localeMap[i18n.getLocale()] || 'en-US';
      return d.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' });
    },

    debounce(fn, delay) {
      let timeoutId;
      return function(...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => fn.apply(this, args), delay);
      };
    },

    isEmpty(str) {
      return !str || !str.trim();
    },

    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
  };

  // ==========================================================================
  // Storage Module (with Safari Private Browsing fallback)
  // ==========================================================================
  const storage = (function() {
    let memoryStorage = {};
    let isAvailable = true;

    try {
      const test = '__storage_test__';
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
    } catch (e) {
      isAvailable = false;
    }

    return {
      getItem(key) {
        if (isAvailable) {
          return localStorage.getItem(key);
        }
        return memoryStorage[key] || null;
      },
      setItem(key, value) {
        if (isAvailable) {
          localStorage.setItem(key, value);
        } else {
          memoryStorage[key] = value;
        }
      },
      removeItem(key) {
        if (isAvailable) {
          localStorage.removeItem(key);
        } else {
          delete memoryStorage[key];
        }
      },
      getSession(key) {
        try {
          return sessionStorage.getItem(key);
        } catch (e) {
          return memoryStorage['session_' + key] || null;
        }
      },
      setSession(key, value) {
        try {
          sessionStorage.setItem(key, value);
        } catch (e) {
          memoryStorage['session_' + key] = value;
        }
      }
    };
  })();

  // ==========================================================================
  // Session Module
  // ==========================================================================
  const session = {
    init() {
      const sessionId = storage.getItem(STORAGE_KEYS.SESSION_ID);
      const lastActivity = storage.getItem(STORAGE_KEYS.LAST_ACTIVITY);

      if (sessionId && lastActivity && !this.isExpired(lastActivity)) {
        state.sessionId = sessionId;
        state.messageCount = parseInt(storage.getItem(STORAGE_KEYS.MSG_COUNT) || '0', 10);
        this.loadHistory();
      } else {
        this.create();
      }

      this.touch();
    },

    create() {
      state.sessionId = utils.generateUUID();
      state.messageCount = 0;
      state.history = [];
      storage.setItem(STORAGE_KEYS.SESSION_ID, state.sessionId);
      storage.setItem(STORAGE_KEYS.MSG_COUNT, '0');
      storage.setSession(STORAGE_KEYS.HISTORY, '[]');
    },

    isExpired(lastActivity) {
      const last = new Date(lastActivity).getTime();
      const now = Date.now();
      return (now - last) > config.sessionTimeout;
    },

    touch() {
      storage.setItem(STORAGE_KEYS.LAST_ACTIVITY, new Date().toISOString());
    },

    incrementCount() {
      state.messageCount++;
      storage.setItem(STORAGE_KEYS.MSG_COUNT, state.messageCount.toString());
    },

    loadHistory() {
      try {
        const history = storage.getSession(STORAGE_KEYS.HISTORY);
        state.history = history ? JSON.parse(history) : [];
      } catch (e) {
        state.history = [];
      }
    },

    saveHistory() {
      try {
        const historyToSave = state.history.slice(-20);
        storage.setSession(STORAGE_KEYS.HISTORY, JSON.stringify(historyToSave));
      } catch (e) {
        // Ignore storage errors
      }
    },

    addToHistory(role, message) {
      state.history.push({
        role,
        message,
        timestamp: new Date().toISOString()
      });
      this.saveHistory();
    }
  };

  // ==========================================================================
  // API Module
  // ==========================================================================
  const api = {
    async sendMessage(message) {
      const payload = {
        message: utils.sanitizeInput(message),
        sessionId: state.sessionId,
        timestamp: new Date().toISOString(),
        context: {
          currentPage: window.location.pathname,
          cartValue: this.getCartValue(),
          isNewSession: state.messageCount === 0
        }
      };

      let lastError = null;

      for (let attempt = 0; attempt < config.retryAttempts; attempt++) {
        if (attempt > 0) {
          await utils.sleep(config.retryDelay * attempt);
        }

        try {
          const controller = new AbortController();
          const timeoutId = setTimeout(() => controller.abort(), 30000);

          const response = await fetch(config.apiUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
            signal: controller.signal
          });

          clearTimeout(timeoutId);

          if (response.status === 429) {
            const data = await response.json();
            state.isRateLimited = true;
            throw { type: 'rate_limit', data };
          }

          if (response.status >= 500) {
            const data = await response.json().catch(() => ({}));
            throw { type: 'server', data };
          }

          if (!response.ok) {
            throw { type: 'unknown', status: response.status };
          }

          return await response.json();

        } catch (error) {
          lastError = error;

          if (error.type === 'rate_limit') {
            throw error;
          }

          if (error.name === 'AbortError') {
            lastError = { type: 'timeout' };
          }

          if (attempt === config.retryAttempts - 1) {
            throw lastError;
          }
        }
      }

      throw lastError;
    },

    getCartValue() {
      if (window.Shopify && window.Shopify.cart) {
        return window.Shopify.cart.total_price / 100;
      }
      return 0;
    },

    logEvent(eventType, data = {}) {
      const analyticsUrl = config.apiUrl.replace(/\/cs-bot-[^/]+$/, '/chatbot-analytics');

      const payload = {
        event: eventType,
        sessionId: state.sessionId,
        timestamp: new Date().toISOString(),
        page: window.location.pathname,
        ...data
      };

      fetch(analyticsUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).catch(() => {});
    },

    async submitFeedback(rating, comment = '') {
      const feedbackUrl = config.apiUrl.replace(/\/chat$/, '/feedback');

      const payload = {
        sessionId: state.sessionId,
        rating: rating,
        comment: utils.sanitizeInput(comment),
        context: {
          currentPage: window.location.pathname,
          messageCount: state.messageCount
        }
      };

      const response = await fetch(feedbackUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error('Feedback submission failed: ' + response.status);
      }

      return response.json();
    }
  };

  // ==========================================================================
  // Feedback Module
  // ==========================================================================
  const feedback = {
    rating: 0,

    init() {
      const submitted = storage.getSession(STORAGE_KEYS.FEEDBACK_SUBMITTED);
      if (submitted === 'true') {
        state.feedbackSubmitted = true;
        this.updateButtonState();
      }
    },

    open() {
      if (state.feedbackSubmitted) return;
      state.isFeedbackOpen = true;
      ui.elements.feedbackModal.classList.add('chatbot-widget__feedback-modal--visible');
      ui.elements.feedbackStars.querySelector('.chatbot-widget__star').focus();
    },

    close() {
      state.isFeedbackOpen = false;
      ui.elements.feedbackModal.classList.remove('chatbot-widget__feedback-modal--visible');
      this.reset();
    },

    reset() {
      this.rating = 0;
      ui.elements.feedbackStars.querySelectorAll('.chatbot-widget__star').forEach(star => {
        star.classList.remove('chatbot-widget__star--active', 'chatbot-widget__star--hover');
        star.setAttribute('aria-checked', 'false');
      });
      ui.elements.feedbackComment.value = '';
      ui.elements.feedbackSubmit.disabled = true;
      ui.elements.feedbackSubmit.textContent = i18n.t('feedbackSubmit');
      ui.elements.feedbackHint.textContent = '';
      ui.elements.feedbackSuccess.classList.add('chatbot-widget__banner--hidden');
    },

    setRating(value) {
      this.rating = value;
      const stars = ui.elements.feedbackStars.querySelectorAll('.chatbot-widget__star');

      stars.forEach((star, index) => {
        const isActive = index < value;
        star.classList.toggle('chatbot-widget__star--active', isActive);
        star.setAttribute('aria-checked', index === value - 1 ? 'true' : 'false');
      });

      const hints = ['', i18n.t('feedbackHint1'), i18n.t('feedbackHint2'), i18n.t('feedbackHint3'), i18n.t('feedbackHint4'), i18n.t('feedbackHint5')];
      ui.elements.feedbackHint.textContent = hints[value] || '';

      ui.elements.feedbackSubmit.disabled = false;
    },

    handleStarHover(value) {
      if (state.feedbackSubmitted) return;
      const stars = ui.elements.feedbackStars.querySelectorAll('.chatbot-widget__star');
      stars.forEach((star, index) => {
        star.classList.toggle('chatbot-widget__star--hover', index < value);
      });
    },

    handleStarLeave() {
      const stars = ui.elements.feedbackStars.querySelectorAll('.chatbot-widget__star');
      stars.forEach(star => {
        star.classList.remove('chatbot-widget__star--hover');
      });
    },

    async submit() {
      if (this.rating === 0 || state.feedbackSubmitted) return;

      const comment = ui.elements.feedbackComment.value.trim();

      ui.elements.feedbackSubmit.disabled = true;
      ui.elements.feedbackSubmit.textContent = i18n.t('feedbackSubmitting');

      try {
        await api.submitFeedback(this.rating, comment);

        state.feedbackSubmitted = true;
        storage.setSession(STORAGE_KEYS.FEEDBACK_SUBMITTED, 'true');

        ui.elements.feedbackSuccess.classList.remove('chatbot-widget__banner--hidden');
        this.updateButtonState();

        api.logEvent('feedback_submitted', { rating: this.rating, hasComment: comment.length > 0 });

        setTimeout(() => this.close(), 2000);

      } catch (error) {
        console.error('Feedback submission failed:', error);
        ui.elements.feedbackSubmit.textContent = i18n.t('feedbackError');
        ui.elements.feedbackSubmit.disabled = false;
      }
    },

    updateButtonState() {
      const btn = ui.elements.feedbackBtn;
      if (state.feedbackSubmitted && btn) {
        btn.disabled = true;
        btn.classList.add('chatbot-widget__feedback--submitted');
        btn.setAttribute('aria-label', i18n.t('feedbackAlreadySent'));
        btn.innerHTML = `
          <svg class="chatbot-widget__feedback-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="currentColor"/>
          </svg>
        `;
      }
    }
  };

  // ==========================================================================
  // UI Module
  // ==========================================================================
  const ui = {
    elements: {},

    init() {
      this.createElements();
      this.attachEventListeners();
      this.loadSavedMessages();

      if (config.enableProactive && config.autoOpenDelay > 0) {
        setTimeout(() => this.showProactiveBadge(), config.autoOpenDelay);
      }
    },

    createElements() {
      const container = document.createElement('div');
      container.className = 'chatbot-widget';
      container.id = 'chatbot-widget';
      container.setAttribute('role', 'complementary');
      container.setAttribute('aria-label', 'Chat support');

      container.innerHTML = `
        <button class="chatbot-widget__button chatbot-widget__button--pulse" id="chatbot-toggle" aria-label="Open chat support" aria-expanded="false" aria-controls="chatbot-panel">
          <svg class="chatbot-widget__button-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z" fill="currentColor"/>
          </svg>
          <span class="chatbot-widget__badge" aria-label="New message" hidden></span>
        </button>

        <div class="chatbot-widget__panel" id="chatbot-panel" role="dialog" aria-labelledby="chatbot-title">
          <header class="chatbot-widget__header">
            <span class="chatbot-widget__header-status" aria-label="Online"></span>
            <span class="chatbot-widget__header-title" id="chatbot-title">Mr. Sneakerseller Support</span>
            <button class="chatbot-widget__feedback" id="chatbot-feedback-btn" aria-label="${i18n.t('feedbackButton')}" title="${i18n.t('feedbackButton')}">
              <svg class="chatbot-widget__feedback-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="currentColor"/>
              </svg>
            </button>
            <button class="chatbot-widget__close" aria-label="Close chat">
              <svg class="chatbot-widget__close-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
          </header>

          <div class="chatbot-widget__offline chatbot-widget__banner--hidden" role="alert">
            ${i18n.t('offlineMessage')}
          </div>

          <div class="chatbot-widget__error chatbot-widget__banner--hidden" role="alert"></div>

          <div class="chatbot-widget__rate-limit chatbot-widget__banner--hidden" role="alert" id="chatbot-rate-limit-banner">
          </div>

          <div class="chatbot-widget__messages" id="chatbot-messages" role="log" aria-live="polite" aria-label="Chat messages">
            <div class="chatbot-widget__typing chatbot-widget__typing--hidden" aria-label="Bot is typing">
              <span class="chatbot-widget__typing-dot"></span>
              <span class="chatbot-widget__typing-dot"></span>
              <span class="chatbot-widget__typing-dot"></span>
            </div>
          </div>

          <div class="chatbot-widget__quick-actions" id="chatbot-quick-actions" role="group" aria-label="Quick actions"></div>

          <div class="chatbot-widget__input-area">
            <div class="chatbot-widget__input-wrapper">
              <textarea class="chatbot-widget__input" id="chatbot-input" placeholder="${i18n.t('inputPlaceholder')}" aria-label="Type your message" maxlength="${config.maxMessageLength}" rows="1"></textarea>
              <span class="chatbot-widget__char-counter chatbot-widget__banner--hidden" id="chatbot-char-counter">
                <span id="chatbot-char-count">0</span>/${config.maxMessageLength}
              </span>
            </div>
            <button class="chatbot-widget__send" id="chatbot-send" aria-label="Send message" disabled>
              <svg class="chatbot-widget__send-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M2.01 21L23 12L2.01 3L2 10L17 12L2 14L2.01 21Z" fill="currentColor"/>
              </svg>
            </button>
          </div>

          <div class="chatbot-widget__feedback-modal" id="chatbot-feedback-modal" role="dialog" aria-labelledby="feedback-title" aria-modal="true">
            <div class="chatbot-widget__feedback-content">
              <button class="chatbot-widget__feedback-close" id="feedback-close" aria-label="${i18n.t('feedbackClose')}">
                <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
                  <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                </svg>
              </button>
              <h3 class="chatbot-widget__feedback-title" id="feedback-title">${i18n.t('feedbackTitle')}</h3>
              <div class="chatbot-widget__feedback-stars" id="feedback-stars" role="radiogroup" aria-label="${i18n.t('feedbackRating')}">
                <button class="chatbot-widget__star" data-rating="1" aria-label="${i18n.t('feedbackStar1')}" role="radio" aria-checked="false">
                  <svg viewBox="0 0 24 24"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/></svg>
                </button>
                <button class="chatbot-widget__star" data-rating="2" aria-label="${i18n.t('feedbackStar2')}" role="radio" aria-checked="false">
                  <svg viewBox="0 0 24 24"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/></svg>
                </button>
                <button class="chatbot-widget__star" data-rating="3" aria-label="${i18n.t('feedbackStar3')}" role="radio" aria-checked="false">
                  <svg viewBox="0 0 24 24"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/></svg>
                </button>
                <button class="chatbot-widget__star" data-rating="4" aria-label="${i18n.t('feedbackStar4')}" role="radio" aria-checked="false">
                  <svg viewBox="0 0 24 24"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/></svg>
                </button>
                <button class="chatbot-widget__star" data-rating="5" aria-label="${i18n.t('feedbackStar5')}" role="radio" aria-checked="false">
                  <svg viewBox="0 0 24 24"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/></svg>
                </button>
              </div>
              <p class="chatbot-widget__feedback-hint" id="feedback-hint"></p>
              <textarea class="chatbot-widget__feedback-comment" id="feedback-comment" placeholder="${i18n.t('feedbackComment')}" maxlength="500" rows="3"></textarea>
              <button class="chatbot-widget__feedback-submit" id="feedback-submit" disabled>${i18n.t('feedbackSubmit')}</button>
              <div class="chatbot-widget__feedback-success chatbot-widget__banner--hidden" id="feedback-success">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="currentColor"/></svg>
                <span>${i18n.t('feedbackSuccess')}</span>
              </div>
            </div>
          </div>
        </div>
      `;

      document.body.appendChild(container);

      this.elements = {
        container,
        button: container.querySelector('#chatbot-toggle'),
        panel: container.querySelector('#chatbot-panel'),
        close: container.querySelector('.chatbot-widget__close'),
        messages: container.querySelector('#chatbot-messages'),
        typing: container.querySelector('.chatbot-widget__typing'),
        input: container.querySelector('#chatbot-input'),
        send: container.querySelector('#chatbot-send'),
        quickActions: container.querySelector('#chatbot-quick-actions'),
        charCounter: container.querySelector('#chatbot-char-counter'),
        charCount: container.querySelector('#chatbot-char-count'),
        offline: container.querySelector('.chatbot-widget__offline'),
        error: container.querySelector('.chatbot-widget__error'),
        rateLimit: container.querySelector('#chatbot-rate-limit-banner'),
        badge: container.querySelector('.chatbot-widget__badge'),
        feedbackBtn: container.querySelector('#chatbot-feedback-btn'),
        feedbackModal: container.querySelector('#chatbot-feedback-modal'),
        feedbackStars: container.querySelector('#feedback-stars'),
        feedbackComment: container.querySelector('#feedback-comment'),
        feedbackSubmit: container.querySelector('#feedback-submit'),
        feedbackSuccess: container.querySelector('#feedback-success'),
        feedbackHint: container.querySelector('#feedback-hint'),
        feedbackClose: container.querySelector('#feedback-close')
      };

      if (config.primaryColor) {
        container.style.setProperty('--chatbot-primary-color', config.primaryColor);
      }

      this.renderQuickActions(getDefaultQuickActions());
    },

    attachEventListeners() {
      this.elements.button.addEventListener('click', () => this.toggle());
      this.elements.close.addEventListener('click', () => this.close());
      this.elements.send.addEventListener('click', () => this.handleSend());

      this.elements.input.addEventListener('input', utils.debounce(() => {
        this.updateCharCounter();
        this.updateSendButton();
        this.autoGrowInput();
      }, 50));

      this.elements.input.addEventListener('keydown', (e) => this.handleKeyDown(e));

      this.elements.quickActions.addEventListener('click', (e) => {
        const btn = e.target.closest('.chatbot-widget__quick-action, .chatbot-widget__product-card');
        if (btn) this.handleQuickAction(btn);
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          if (state.isFeedbackOpen) {
            feedback.close();
          } else if (state.isOpen) {
            this.close();
          }
        }
      });

      // Feedback event listeners
      this.elements.feedbackBtn.addEventListener('click', () => feedback.open());
      this.elements.feedbackClose.addEventListener('click', () => feedback.close());

      this.elements.feedbackStars.addEventListener('click', (e) => {
        const star = e.target.closest('.chatbot-widget__star');
        if (star) {
          feedback.setRating(parseInt(star.dataset.rating, 10));
        }
      });

      this.elements.feedbackStars.addEventListener('mouseover', (e) => {
        const star = e.target.closest('.chatbot-widget__star');
        if (star) {
          feedback.handleStarHover(parseInt(star.dataset.rating, 10));
        }
      });

      this.elements.feedbackStars.addEventListener('mouseleave', () => {
        feedback.handleStarLeave();
      });

      this.elements.feedbackSubmit.addEventListener('click', () => feedback.submit());

      this.elements.feedbackModal.addEventListener('click', (e) => {
        if (e.target === this.elements.feedbackModal) {
          feedback.close();
        }
      });

      window.addEventListener('online', () => {
        state.isOffline = false;
        this.hideOffline();
        this.enableInput();
      });

      window.addEventListener('offline', () => {
        state.isOffline = true;
        this.showOffline();
        this.disableInput();
      });

      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', utils.debounce(() => {
          this.adjustForKeyboard();
        }, 100));
      }
    },

    toggle() {
      if (state.isOpen) {
        this.close();
      } else {
        this.open();
      }
    },

    open() {
      state.isOpen = true;
      this.elements.panel.classList.add('chatbot-widget__panel--visible');
      this.elements.button.classList.add('chatbot-widget__button--hidden');
      this.elements.button.setAttribute('aria-expanded', 'true');
      this.elements.badge.hidden = true;
      this.scrollToBottom();
      this.elements.input.focus();
      api.logEvent('widget_opened');

      if (state.history.length === 0) {
        this.addBotMessage(i18n.t('welcomeMessage'));
      }
    },

    close() {
      state.isOpen = false;
      this.elements.panel.classList.remove('chatbot-widget__panel--visible');
      this.elements.button.classList.remove('chatbot-widget__button--hidden');
      this.elements.button.setAttribute('aria-expanded', 'false');
      api.logEvent('widget_closed');
    },

    loadSavedMessages() {
      if (state.history.length > 0) {
        state.history.forEach(msg => {
          this.renderMessage(msg.role, msg.message, msg.timestamp, false);
        });
      }
    },

    async handleSend() {
      const message = this.elements.input.value.trim();

      if (utils.isEmpty(message) || state.isLoading || state.isRateLimited || state.isOffline) {
        return;
      }

      this.elements.input.value = '';
      this.updateSendButton();
      this.updateCharCounter();
      this.autoGrowInput();

      this.addUserMessage(message);

      if (state.messageCount >= 20) {
        state.isRateLimited = true;
        this.showRateLimitReached();
        return;
      }

      session.incrementCount();
      session.touch();

      this.updateRateLimitWarning();
      this.showTyping();
      this.disableInput();

      try {
        const response = await api.sendMessage(message);
        this.hideTyping();
        this.enableInput();

        if (response.response) {
          this.addBotMessage(response.response);
        }

        if (response.quickActions && response.quickActions.length > 0) {
          state.dynamicActions = response.quickActions;
          this.renderDynamicActions(response.quickActions);
        } else {
          state.dynamicActions = null;
          this.renderQuickActions(getDefaultQuickActions());
        }

        if (response.shouldEscalate) {
          api.logEvent('escalation_shown');
        }

      } catch (error) {
        this.hideTyping();
        this.enableInput();
        this.handleError(error);
      }
    },

    handleKeyDown(e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        this.handleSend();
      }
    },

    handleQuickAction(btn) {
      const action = btn.dataset.action;
      const value = btn.dataset.value;

      if (action === 'message') {
        this.elements.input.value = value;
        this.handleSend();
        api.logEvent('quick_action_clicked', { label: btn.textContent.trim() });
      } else if (action === 'mailto') {
        window.location.href = value;
        api.logEvent('quick_action_clicked', { label: btn.textContent.trim() });
      } else if (action === 'navigate') {
        window.location.href = value;
        api.logEvent('quick_action_clicked', { label: btn.textContent.trim() });
      }
    },

    addUserMessage(message) {
      session.addToHistory('user', message);
      this.renderMessage('user', message, new Date().toISOString());
      api.logEvent('message_sent', { message });
    },

    addBotMessage(message) {
      session.addToHistory('bot', message);
      this.renderMessage('bot', message, new Date().toISOString());
    },

    renderMessage(role, content, timestamp, shouldScroll = true) {
      const wrapper = document.createElement('div');
      wrapper.className = `chatbot-widget__message chatbot-widget__message--${role}`;

      const messageEl = document.createElement('div');
      messageEl.className = 'chatbot-widget__message-content';

      if (role === 'bot') {
        messageEl.innerHTML = this.sanitizeBotMessage(content);
      } else {
        messageEl.textContent = content;
      }

      const timeEl = document.createElement('span');
      timeEl.className = 'chatbot-widget__message-time';
      timeEl.textContent = utils.formatTimestamp(timestamp);

      wrapper.appendChild(messageEl);
      wrapper.appendChild(timeEl);

      this.elements.typing.before(wrapper);

      if (shouldScroll) {
        this.scrollToBottom();
      }
    },

    sanitizeBotMessage(html) {
      const allowed = /<(\/?(p|a|strong|em|br|ul|li|ol))(?: href="([^"]*)")?[^>]*>/gi;
      let result = html;

      result = result.replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '');
      result = result.replace(/<iframe[^>]*>[\s\S]*?<\/iframe>/gi, '');
      result = result.replace(/on\w+\s*=\s*["'][^"']*["']/gi, '');
      result = result.replace(/\n/g, '<br>');

      return result;
    },

    renderQuickActions(actions) {
      this.elements.quickActions.innerHTML = actions.map(action => `
        <button class="chatbot-widget__quick-action" data-action="${action.action}" data-value="${action.value || action.url || ''}" ${state.isRateLimited ? 'disabled' : ''}>
          <span aria-hidden="true">${action.emoji || ''}</span> ${action.label}
        </button>
      `).join('');
    },

    renderDynamicActions(actions) {
      const dynamicHtml = actions.map(action => {
        if (action.image) {
          // Product card with image
          return `
            <button class="chatbot-widget__product-card" data-action="${action.action}" data-value="${action.url || ''}" ${state.isRateLimited ? 'disabled' : ''}>
              <img class="chatbot-widget__product-image" src="${action.image}" alt="${action.label}" loading="lazy" onerror="this.parentElement.classList.add('chatbot-widget__product-card--no-image')" />
              <span class="chatbot-widget__product-label">${action.label}</span>
            </button>
          `;
        }
        // Regular button without image
        return `
          <button class="chatbot-widget__quick-action" data-action="${action.action}" data-value="${action.url || ''}" ${state.isRateLimited ? 'disabled' : ''}>
            ${action.label}
          </button>
        `;
      }).join('');

      this.elements.quickActions.innerHTML = dynamicHtml;
    },

    showTyping() {
      state.isLoading = true;
      this.elements.typing.classList.remove('chatbot-widget__typing--hidden');
      this.scrollToBottom();
    },

    hideTyping() {
      state.isLoading = false;
      this.elements.typing.classList.add('chatbot-widget__typing--hidden');
    },

    showOffline() {
      this.elements.offline.classList.remove('chatbot-widget__banner--hidden');
    },

    hideOffline() {
      this.elements.offline.classList.add('chatbot-widget__banner--hidden');
    },

    showError(message) {
      this.elements.error.textContent = message;
      this.elements.error.classList.remove('chatbot-widget__banner--hidden');
      api.logEvent('error_occurred', { message });
    },

    hideError() {
      this.elements.error.classList.add('chatbot-widget__banner--hidden');
    },

    handleError(error) {
      let message = i18n.t('errorGeneric');

      if (error.type === 'rate_limit') {
        this.showRateLimitReached();
        return;
      } else if (error.type === 'timeout') {
        message = i18n.t('errorTimeout');
      } else if (error.type === 'server' && error.data && error.data.message) {
        message = error.data.message;
      } else if (!navigator.onLine) {
        message = i18n.t('errorOffline');
      }

      this.addBotMessage(message);
    },

    updateRateLimitWarning() {
      const remaining = 20 - state.messageCount;

      if (remaining <= 2 && remaining > 0) {
        this.elements.rateLimit.textContent = i18n.t('rateLimitWarning', { remaining });
        this.elements.rateLimit.classList.remove('chatbot-widget__banner--hidden');
      }
    },

    showRateLimitReached() {
      this.elements.rateLimit.classList.add('chatbot-widget__banner--hidden');
      this.addBotMessage(i18n.t('rateLimitReached'));
      this.disableInput();

      this.elements.quickActions.innerHTML = `
        <button class="chatbot-widget__quick-action" data-action="mailto" data-value="mailto:support@mrsneakerseller.ch?subject=${i18n.t('quickAction_emailSubject')}">
          <span aria-hidden="true">\u{1F4AC}</span> ${i18n.t('quickAction_email')}
        </button>
      `;
    },

    disableInput() {
      this.elements.input.disabled = true;
      this.elements.send.disabled = true;

      const actions = this.elements.quickActions.querySelectorAll('.chatbot-widget__quick-action, .chatbot-widget__product-card');
      actions.forEach(btn => {
        if (btn.dataset.action === 'message') {
          btn.disabled = true;
        }
      });
    },

    enableInput() {
      if (!state.isRateLimited && !state.isOffline) {
        this.elements.input.disabled = false;
        this.updateSendButton();

        const actions = this.elements.quickActions.querySelectorAll('.chatbot-widget__quick-action, .chatbot-widget__product-card');
        actions.forEach(btn => btn.disabled = false);
      }
    },

    updateSendButton() {
      const hasContent = !utils.isEmpty(this.elements.input.value);
      const canSend = hasContent && !state.isLoading && !state.isRateLimited && !state.isOffline;
      this.elements.send.disabled = !canSend;
    },

    updateCharCounter() {
      const length = this.elements.input.value.length;
      this.elements.charCount.textContent = length;

      if (length >= 450) {
        this.elements.charCounter.classList.remove('chatbot-widget__banner--hidden');

        if (length >= config.maxMessageLength) {
          this.elements.charCounter.classList.add('chatbot-widget__char-counter--error');
          this.elements.charCounter.classList.remove('chatbot-widget__char-counter--warning');
        } else {
          this.elements.charCounter.classList.add('chatbot-widget__char-counter--warning');
          this.elements.charCounter.classList.remove('chatbot-widget__char-counter--error');
        }
      } else {
        this.elements.charCounter.classList.add('chatbot-widget__banner--hidden');
        this.elements.charCounter.classList.remove('chatbot-widget__char-counter--warning', 'chatbot-widget__char-counter--error');
      }
    },

    autoGrowInput() {
      const input = this.elements.input;
      input.style.height = 'auto';
      input.style.height = Math.min(input.scrollHeight, 100) + 'px';
    },

    scrollToBottom() {
      requestAnimationFrame(() => {
        this.elements.messages.scrollTop = this.elements.messages.scrollHeight;
      });
    },

    adjustForKeyboard() {
      if (!state.isOpen || !window.visualViewport) return;

      const panel = this.elements.panel;
      const viewport = window.visualViewport;
      const keyboardHeight = window.innerHeight - viewport.height;

      if (keyboardHeight > 100) {
        panel.style.height = viewport.height + 'px';
        panel.style.bottom = keyboardHeight + 'px';
      } else {
        panel.style.height = '';
        panel.style.bottom = '';
      }
    },

    showProactiveBadge() {
      if (!state.isOpen && state.history.length === 0) {
        this.elements.badge.hidden = false;
      }
    }
  };

  // ==========================================================================
  // Initialize
  // ==========================================================================
  function init() {
    if (!config.apiUrl) {
      console.warn('Chatbot: No API URL configured');
      return;
    }

    i18n.init();
    session.init();
    ui.init();
    feedback.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
